function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function setToggleIconsState(buttons, isOpen, displayValue = "block") {
  buttons.forEach((button) => {
    const hamburgerIcon = button.querySelector(".categories-hamburger-icon");
    const closeIcon = button.querySelector(".categories-close-icon");

    if (!hamburgerIcon || !closeIcon) return;

    hamburgerIcon.style.display = isOpen ? "none" : displayValue;
    closeIcon.style.display = isOpen ? displayValue : "none";
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  const hamburgerIcon = summary.querySelector(".categories-hamburger-icon");
  const closeIcon = summary.querySelector(".categories-close-icon");

  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
    if (summary.classList.contains("header__icon--summary")) {
      const isOpen = !event.currentTarget.closest("details").hasAttribute("open");

      if (hamburgerIcon && closeIcon) {
        hamburgerIcon.style.display = isOpen ? "none" : "flex";
        closeIcon.style.display = isOpen ? "flex" : "none";
      }
    }
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

if (typeof trapFocusHandlers === "undefined") {
  var trapFocusHandlers = {};
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

if (typeof QuantityInput === "undefined") {
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}
if (!customElements.get("quantity-input"))
  customElements.define("quantity-input", QuantityInput);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );

    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  closeOthers(summaryElement) {
    const list = summaryElement.closest("ul");
    if (!list) {
      return;
    }
    const details = list.querySelectorAll("details.menu-opening");
    details.forEach((detail) => {
      if (detail.hasAttribute("open")) {
        detail.querySelector("summary")?.click();
      }
    });
  }

  onSummaryClick(event) {
    if (event.target.closest(".facet-filters-form-el")) {
      return;
    }
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    this.closeOthers(summaryElement);
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        )}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

const checkCustomerType = async () => {
  let customerType = "Consumer";

  if (window.customerTags.includes("Wholesaler")) {
    customerType = "Wholesaler";
  }
  if (window.customerTags.includes("Truckload-buyer")) {
    customerType = "Truckload-buyer";
  }
  const savedCustomerType = localStorage.getItem("saved-customer-type");
  if (!savedCustomerType) {
    localStorage.setItem("saved-customer-type", customerType);
    return;
  }
  if (customerType !== savedCustomerType) {
    localStorage.setItem("saved-customer-type", customerType);

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  window.dispatchEvent(new CustomEvent("check::variant-in-cart"));

  //check customer type
  checkCustomerType();
});

window.addEventListener("load", () => {
  setTimeout(() => {
    document.documentElement.style.scrollPaddingTop = "0px";
  }, 1);
});

function getDrawerLayoutRefs() {
  return {
    stickyHeader: document.querySelector("sticky-header"),
    announcementBar: document.querySelector(".announcement-bar-section"),
    headerNav: document.querySelector(".product-categories-nav"),
    sectionHeader: document.querySelector(".section-header"),
    root: document.documentElement,
  };
}

function getDrawerLayoutMetrics(refs) {
  const stickyHeaderHeight = refs.stickyHeader?.offsetHeight || 80;
  const announcementBarHeight = refs.announcementBar?.offsetHeight || 0;
  const headerNavHeight = refs.headerNav?.offsetHeight || 0;
  const announcementVisibleHeight = Math.max(
    announcementBarHeight - window.scrollY,
    0,
  );
  const announcementCollapsed = window.scrollY >= announcementBarHeight;

  return {
    stickyHeaderHeight,
    announcementBarHeight,
    announcementVisibleHeight,
    announcementCollapsed,
    headerNavHeight,
    viewportHeight: window.innerHeight,
  };
}

function setupOpenStateListener(instance, onUpdate) {
  if (instance.scrollListener) return;

  let ticking = false;
  instance.scrollListener = () => {
    if (!instance.classList.contains("open") || ticking) return;

    ticking = true;
    requestAnimationFrame(() => {
      onUpdate();
      ticking = false;
    });
  };

  window.addEventListener("scroll", instance.scrollListener, { passive: true });
  window.addEventListener("resize", instance.scrollListener);

  if (instance.layoutRefs.sectionHeader) {
    instance.headerObserver = new MutationObserver(() => {
      if (instance.classList.contains("open")) {
        onUpdate();
      }
    });
    instance.headerObserver.observe(instance.layoutRefs.sectionHeader, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
}

function removeOpenStateListener(instance) {
  if (instance.scrollListener) {
    window.removeEventListener("scroll", instance.scrollListener);
    window.removeEventListener("resize", instance.scrollListener);
    instance.scrollListener = null;
  }

  if (instance.headerObserver) {
    instance.headerObserver.disconnect();
    instance.headerObserver = null;
  }
}

class CategoriesDrawer extends HTMLElement {
  constructor() {
    super();
    this.layoutRefs = getDrawerLayoutRefs();
    this.container = this.querySelector(".cd__container");
    this.overlay = this.querySelector(".overlay");
    this.triggerButtons = Array.from(
      document.querySelectorAll(".header-categories-button"),
    );

    this._initTopPosition();

    this._initMenuCollapse();
    this._openingTriggers();
    this._closingTriggers();
  }
  _initTopPosition() {
    const metrics = getDrawerLayoutMetrics(this.layoutRefs);

    if (!this.layoutRefs.headerNav || !this.container) {
      console.error("Error header container not found");
      return;
    }

    const totalStickyHeight =
      metrics.announcementCollapsed
        ? metrics.stickyHeaderHeight
        : metrics.stickyHeaderHeight + metrics.announcementBarHeight;
    const topPosition = totalStickyHeight + metrics.headerNavHeight;
    const containerHeight =
      metrics.viewportHeight -
      topPosition;

    this.container.style.top = `${topPosition}px`;
    this.container.style.height = `${containerHeight}px`;
  }
  _setupScrollListener() {
    setupOpenStateListener(this, () => this._initTopPosition());
  }
  _removeScrollListener() {
    removeOpenStateListener(this);
  }
  _initMenuCollapse() {
    this.querySelectorAll(".cd__category-title").forEach((title) => {
      title.addEventListener("click", () => {
        title.classList.toggle("opened");
      });
    });
  }
  _open() {
    this._initTopPosition();
    this._setupScrollListener();
    this.classList.add("opening");
    this._toggleIcons(true);
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
      this.layoutRefs.root.classList.add("categories-drawer-opened");
    }, 60);
  }
  _close() {
    this.classList.add("closing");
    this._toggleIcons(false);
    this._removeScrollListener();
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
      this.layoutRefs.root.classList.remove("categories-drawer-opened");
    }, 600);
  }
  open() {
    this._open();
  }
  _openingTriggers() {
    this.triggerButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this._open();
      });
    });
  }
  _closingTriggers() {
    this.overlay.addEventListener("click", () => {
      this._close();
    });
    this.triggerButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        if (this.classList.contains("open")) {
          e.preventDefault();
          this._close();
        }
      });
    });
  }

  _toggleIcons(isOpen) {
    setToggleIconsState(this.triggerButtons, isOpen);
  }
}

customElements.define("categories-drawer", CategoriesDrawer);

class HfdDropdown extends HTMLElement {
  constructor() {
    super();
    this.layoutRefs = getDrawerLayoutRefs();
    this.container = this.querySelector(".hfd__container");
    this.overlay = this.querySelector(".overlay");
    this.triggerButtons = Array.from(document.querySelectorAll(".hfd__btn"));

    this._initTopPosition();

    this._openingTriggers();
    this._closingTriggers();
  }
  _initTopPosition() {
    const metrics = getDrawerLayoutMetrics(this.layoutRefs);

    if (!this.layoutRefs.headerNav || !this.container) {
      console.error("Error header container not found");
      return;
    }

    const totalStickyHeight =
      metrics.announcementCollapsed
        ? metrics.stickyHeaderHeight + metrics.headerNavHeight
        : metrics.stickyHeaderHeight +
          metrics.headerNavHeight +
          metrics.announcementBarHeight;
    const topPosition = totalStickyHeight;
    const containerHeight =
      metrics.viewportHeight -
      totalStickyHeight -
      metrics.announcementVisibleHeight -
      metrics.headerNavHeight;

    this.container.style.top = `${topPosition}px`;
    this.container.style.height = `${containerHeight}px`;
  }
  _setupScrollListener() {
    setupOpenStateListener(this, () => this._initTopPosition());
  }
  _removeScrollListener() {
    removeOpenStateListener(this);
  }

  _open() {
    this._initTopPosition();
    this._setupScrollListener();
    this.classList.add("opening");
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
      this.layoutRefs.root.classList.add("featured-drawer-opened");
    }, 60);
  }
  _close() {
    this.classList.add("closing");
    this._removeScrollListener();
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
      this.layoutRefs.root.classList.remove("featured-drawer-opened");
    }, 600);
  }
  open() {
    this._open();
  }
  _openingTriggers() {
    this.triggerButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this._open();
      });
    });
  }
  _closingTriggers() {
    this.overlay.addEventListener("click", () => {
      this._close();
    });
  }
}

customElements.define("hfd-dropdown", HfdDropdown);

class MainNavDropdown extends HTMLElement {
  constructor() {
    super();
    this.layoutRefs = getDrawerLayoutRefs();
    this.container = this.querySelector(".mnd__container");
    this.overlay = this.querySelector(".overlay");
    this.triggerButtons = Array.from(document.querySelectorAll(".mnd__btn"));

    this._initTopPosition();

    this._openingTriggers();
    this._closingTriggers();
    this._initParentLinks();
    this._initCloseChildrenBox();
    this._initMenuCollapse();
  }
  _initTopPosition() {
    const metrics = getDrawerLayoutMetrics(this.layoutRefs);

    if (!this.layoutRefs.headerNav || !this.container) {
      console.error("Error header container not found");
      return;
    }

    const totalStickyHeight =
      metrics.announcementCollapsed
        ? metrics.stickyHeaderHeight +
          metrics.headerNavHeight +
          metrics.announcementBarHeight
        : metrics.stickyHeaderHeight + metrics.headerNavHeight;
    const topPosition = totalStickyHeight;
    const containerHeight =
      metrics.viewportHeight -
      totalStickyHeight -
      metrics.announcementVisibleHeight -
      metrics.headerNavHeight;

    this.container.style.top = `${topPosition}px`;
    this.container.style.height = `${containerHeight}px`;
  }
  _setupScrollListener() {
    setupOpenStateListener(this, () => this._initTopPosition());
  }
  _removeScrollListener() {
    removeOpenStateListener(this);
  }

  _initMenuCollapse() {
    this.querySelectorAll(".mnd__category-title").forEach((title) => {
      title.addEventListener("click", () => {
        title.classList.toggle("opened");
      });
    });
  }
  _initParentLinks() {
    const parentLinks = this.querySelectorAll(".mnd__row-has-children");
    parentLinks.forEach((link) => {
      link.querySelector(".mnd__title").addEventListener("click", (e) => {
        link.classList.add("opened");
      });
    });
  }

  _initCloseChildrenBox() {
    const childLinksClosers = this.querySelectorAll(".close-children-block");
    childLinksClosers.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => {
        closeBtn.closest(".mnd__row-has-children").classList.remove("opened");
      });
    });
  }

  _open() {
    this._initTopPosition();
    this._setupScrollListener();
    this.classList.add("opening");
    setTimeout(() => {
      this.classList.add("open");
      this.classList.remove("opening");
      this.layoutRefs.root.classList.add("main-nav-opened");
    }, 60);
  }
  _close() {
    this.classList.add("closing");
    this._removeScrollListener();
    setTimeout(() => {
      this.classList.remove("open");
      this.classList.remove("closing");
      this.layoutRefs.root.classList.remove("main-nav-opened");
    }, 600);
  }
  open() {
    this._open();
  }
  _openingTriggers() {
    this.triggerButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        this._open();
      });
    });
  }
  _closingTriggers() {
    this.overlay.addEventListener("click", () => {
      this._close();
    });
    this.overlay.addEventListener("mouseover", () => {
      if (this.classList.contains("open")) this._close();
    });
  }
}

customElements.define("main-nav-dropdown", MainNavDropdown);

//TODO: DELETE IN JULY IF NOT USED
// class ShopPageContent extends HTMLElement {
//   constructor() {
//     super();
//     this.parentElement.classList.remove("show");
//     //this._init();
//   }

//   connectedCallback() {
//     this._init();
//   }

//   _init() {
//     const sections = document.querySelectorAll(
//       ".featured-products-section-class, .further-reduced-section-class, .new-arrivals-section-class"
//     );

//     if (sections.length === 0) {
//       return;
//     }
//     this.innerHTML = "";

//     sections.forEach((section) => {
//       this.innerHTML += section.outerHTML;
//       //this.appendChild(section);
//     });
//     setTimeout(() => {
//       window.dispatchEvent(new Event("resize", { bubbles: true }));
//     }, 80);

//     this.parentElement.classList.add("show");
//   }
// }
// customElements.define("shop-page-content", ShopPageContent);
